import React, { useState } from 'react';
import ProductsNavRow from '../rownavigator';
import { Link } from 'react-router-dom';

const MepProductsPage = () => {
  // State management
  const [activeCategory, setActiveCategory] = useState('mechanical');
  const [activeSubcategory, setActiveSubcategory] = useState(null);
  const [activeOption, setActiveOption] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Data structure (simplified for brevity)
  const mepProducts = {
    mechanical: {
      name: "Mechanical",
      subcategories: {
        air_circulation: {
          name: "Air Circulation",
          options: {
            fans: {
              name: "Fans and Extractors",
              images: ["/assets/productimages/fans.jpg"],
              products: [
                {
                  name: "Industrial Extractor Fan",
                  image: "/assets/exhaustfans/fan1.png",
                  use: "Air circulation systems",
                  details: "High-capacity ventilation fan",
                  price: "$149.99"
                },
                {
                  name: "Axial fan REST D100 mesh back valve ERA",
                  image: "/assets/exhaustfans/fan2.png",
                  use: "Ventilation systems",
                  details: "High-efficiency axial fan with back-draught valve",
                  price: "$129.99"
                },
                {
                  name: "Axial fan WIND D100 back-draught valve",
                  image: "/assets/exhaustfans/fan3.png",
                  use: "Ventilation systems",
                  details: "Compact axial fan with back-draught valve for improved airflow",
                  price: "$139.99"
                },
                {
                  name: "Axial fan WIND D120 back-draught valve",
                  image: "/assets/exhaustfans/fan4.png",
                  use: "Ventilation systems",
                  details: "Larger axial fan with D120 back-draught valve for high efficiency",
                  price: "$159.99"
                },
                {
                  name: "Axial fan WIND D120 back-draught valve",
                  image: "/assets/exhaustfans/fan5.png",
                  use: "Ventilation systems",
                  details: "Larger axial fan with D120 back-draught valve for high efficiency",
                  price: "$159.99"
                }, {
                  name: "Axial fan WIND D120 back-draught valve",
                  image: "/assets/exhaustfans/fan6.png",
                  use: "Ventilation systems",
                  details: "Larger axial fan with D120 back-draught valve for high efficiency",
                  price: "$159.99"
                },
                {
                  name: "Axial fan WIND D120 back-draught valve",
                  image: "/assets/exhaustfans/fan7.png",
                  use: "Ventilation systems",
                  details: "Larger axial fan with D120 back-draught valve for high efficiency",
                  price: "$159.99"
                }, {
                  name: "Axial fan WIND D120 back-draught valve",
                  image: "/assets/exhaustfans/fan8.png",
                  use: "Ventilation systems",
                  details: "Larger axial fan with D120 back-draught valve for high efficiency",
                  price: "$159.99"
                }, {
                  name: "Axial fan WIND D120 back-draught valve",
                  image: "/assets/exhaustfans/fan9.png",
                  use: "Ventilation systems",
                  details: "Larger axial fan with D120 back-draught valve for high efficiency",
                  price: "$159.99"
                },

                {
                  name: "Axial fan WIND D120 back-draught valve",
                  image: "/assets/exhaustfans/fan10.png",
                  use: "Ventilation systems",
                  details: "Larger axial fan with D120 back-draught valve for high efficiency",
                  price: "$159.99"
                }, {
                  name: "Axial fan WIND D120 back-draught valve",
                  image: "/assets/exhaustfans/fan11.png",
                  use: "Ventilation systems",
                  details: "Larger axial fan with D120 back-draught valve for high efficiency",
                  price: "$159.99"
                }, {
                  name: "Axial fan WIND D120 back-draught valve",
                  image: "/assets/exhaustfans/fan12.png",
                  use: "Ventilation systems",
                  details: "Larger axial fan with D120 back-draught valve for high efficiency",
                  price: "$159.99"
                },
                {
                  name: "Axial fan WIND D120 back-draught valve",
                  image: "/assets/exhaustfans/fan13.png",
                  use: "Ventilation systems",
                  details: "Larger axial fan with D120 back-draught valve for high efficiency",
                  price: "$159.99"
                }, {
                  name: "Axial fan WIND D120 back-draught valve",
                  image: "/assets/exhaustfans/fan14.png",
                  use: "Ventilation systems",
                  details: "Larger axial fan with D120 back-draught valve for high efficiency",
                  price: "$159.99"
                },
              ]
            }
          }
        },
        temperature_control: {
          name: "Temperature Control",
          options: {
            hvac: {
              name: "HVAC Systems",
              products: [
                {
                  name: "Commercial HVAC Unit",
                  image: "/assets/productimages/hvac.jpg",
                  use: "Heating, ventilation and air conditioning",
                  details: "Complete climate control system",
                  price: "$2,499.99"
                }
              ]
            }
          }
        }
      }
    },

    electrical_lighting: {
      name: "Electrical & Lighting",
      subcategories: {
        outdoor_lighting: {
          name: "Outdoor Lighting",
          images: ["/assets/outdoor/placeholder.jpg"],
          products: [
            {
              name: "Projectors",
              image: "/assets/outdoor/projectors.webp",
              use: "Outdoor lighting setup",
              details: "Durable LED fixture for outdoor applications",
              price: "$49.99"
            },

            {
              name: "Ceiling Lights",
              image: "/assets/outdoor/ceilinglights.webp",
              use: "Outdoor lighting setup",
              details: "Durable LED fixture for outdoor applications",
              price: "$49.99"
            },
            {
              name: "Wall Lightings",
              image: "/assets/outdoor/walllightings.webp",
              use: "Outdoor lighting setup",
              details: "Durable LED fixture for outdoor applications",
              price: "$49.99"
            },
            {
              name: "Uplights",
              image: "/assets/outdoor/uplights.webp",
              use: "Outdoor lighting setup",
              details: "Durable LED fixture for outdoor applications",
              price: "$49.99"
            },

            {
              name: "Linear Lighting",
              image: "/assets/outdoor/linearlightings.webp",
              use: "Outdoor lighting setup",
              details: "Durable LED fixture for outdoor applications",
              price: "$49.99"
            },
            {
              name: "Linear Lighting",
              image: "/assets/outdoor/linearlightings.webp",
              use: "Outdoor lighting setup",
              details: "Durable LED fixture for outdoor applications",
              price: "$49.99"
            }, {
              name: "Step Lights Lighting",
              image: "/assets/outdoor/steplights.webp",
              use: "Outdoor lighting setup",
              details: "Durable LED fixture for outdoor applications",
              price: "$49.99"
            },
            {
              name: "Bollards and poles",
              image: "/assets/outdoor/bolllardspoles.webp",
              use: "Outdoor lighting setup",
              details: "Durable LED fixture for outdoor applications",
              price: "$49.99"
            }, {
              name: "Lamp posts heads",
              image: "/assets/outdoor/lampposts.webp",
              use: "Outdoor lighting setup",
              details: "Durable LED fixture for outdoor applications",
              price: "$49.99"
            },

            {
              name: "Floor Lamps",
              image: "/assets/outdoor/floorlamps.webp",
              use: "Outdoor lighting setup",
              details: "Durable LED fixture for outdoor applications",
              price: "$49.99"
            }, {
              name: "Under Water",
              image: "/assets/outdoor/underwater.webp",
              use: "Outdoor lighting setup",
              details: "Durable LED fixture for outdoor applications",
              price: "$49.99"
            },


          ]
        },
        Projectors: {
          name: "Projectors",
          images: ["/assets/productimages/landscapelighting.jpg"],
          products: [
          
            {
              name: "Eyelet",
              image: "/assets/productimages/outdoor1.jpeg",
              use: "Project Lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Periskop",
              image: "/assets/productimages/outdoor2.jpeg",
              use: "Project Lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Shaker",
              image: "/assets/productimages/outdoor3.jpeg",
              use: "Project Lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },

            {
              name: "Clasr 316",
              image: "/assets/productimages/outdoor4.jpeg",
              use: "Project Lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            }, {
              name: "Clivo",
              image: "/assets/productimages/outdoor5.jpeg",
              use: "Project Lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Iris6",
              image: "/assets/productimages/outdoor6.jpeg",
              use: "Project Lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },

            {
              name: "Vision",
              image: "/assets/productimages/outdoor7.jpeg",
              use: "Project Lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },

            {
              name: "Vulelta",
              image: "/assets/productimages/outdoor8.jpeg",
              use: "Project Lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Biglamp",
              image: "/assets/productimages/outdoor9.jpeg",
              use: "Project Lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
          ]

        },
        // here
        indoor_lighting: {
          name: "Ceiling & Wall Lights (Indoor)",
          images: ["/assets/outdoorceiling/basin.webp"],
          products: [
            {
              name: "Basin",
              image: "/assets/outdoorceiling/basin.webp",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Cristalbolla",
              image: "/assets/outdoorceiling/Cristalbolla.webp",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Delfi",
              image: "/assets/outdoorceiling/Delfi.webp",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Doge",
              image: "/assets/outdoorceiling/Doge.webp",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },

            {
              name: "Iside",
              image: "/assets/outdoorceiling/iside.webp",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            }, {
              name: "Joint",
              image: "/assets/outdoorceiling/joint.webp",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Stilo",
              image: "/assets/outdoorceiling/stilo.webp",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },

            {
              name: "Tara",
              image: "/assets/outdoorceiling/tara.webp",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Baton",
              image: "/assets/outdoorceiling/baton.webp",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Tour",
              image: "/assets/outdoorceiling/tour.webp",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Baton",
              image: "/assets/outdoorceiling/baton.webp",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Skylum",
              image: "/assets/outdoorceiling/Skylum.webp",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
          ]
        },

        uplights: {
          name: "Uplights",
          images: ["/assets/productimages/skin.jpeg"],
          products: [
            {
              name: "Skin",
              image: "/assets/productimages/skin.jpeg",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Orma",
              image: "/assets/productimages/orma.jpeg",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Alcor",
              image: "/assets/productimages/alcor.jpeg",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },
            {
              name: "Atropek",
              image: "/assets/productimages/atropek.jpeg",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },

            {
              name: "Arcada",
              image: "/assets/productimages/arcada.jpeg",
              use: "Indoor ceiling/wall lighting",
              details: "Energy-efficient LED fixture for interior spaces",
              price: "$29.99"
            },




          ]
        },
        ceiling_lighting: {
          name: "Ceiling Lighting (Outdoor)",
          images: ["/assets/ceilinglight/placeholder.jpg"],
          products: [
            {
              name: "Horus",
              image: "/assets/ceilinglight/horus.webp",
              use: "Ceiling-mounted lighting",
              details: "Modern ceiling fixture with soft illumination",
              price: "$39.99"
            },
            {
              name: "Oh!",
              image: "/assets/ceilinglight/oh.webp",
              use: "Ceiling-mounted lighting",
              details: "Modern ceiling fixture with soft illumination",
              price: "$39.99"
            },
            {
              name: "Xenia",
              image: "/assets/ceilinglight/xenia.webp",
              use: "Ceiling-mounted lighting",
              details: "Modern ceiling fixture with soft illumination",
              price: "$39.99"
            },
            {
              name: "Oh Smash",
              image: "/assets/ceilinglight/ohsmash.webp",
              use: "Ceiling-mounted lighting",
              details: "Modern ceiling fixture with soft illumination",
              price: "$39.99"
            },
            {
              name: "Portik",
              image: "/assets/ceilinglight/portik.webp",
              use: "Ceiling-mounted lighting",
              details: "Modern ceiling fixture with soft illumination",
              price: "$39.99"
            },
            {
              name: "Skin",
              image: "/assets/ceilinglight/skin.webp",
              use: "Ceiling-mounted lighting",
              details: "Modern ceiling fixture with soft illumination",
              price: "$39.99"
            },
            {
              name: "Lira",
              image: "/assets/ceilinglight/lira.webp",
              use: "Ceiling-mounted lighting",
              details: "Modern ceiling fixture with soft illumination",
              price: "$39.99"
            },
            {
              name: "Cem",
              image: "/assets/ceilinglight/cem.webp",
              use: "Ceiling-mounted lighting",
              details: "Modern ceiling fixture with soft illumination",
              price: "$39.99"
            },
            {
              name: "Alex",
              image: "/assets/ceilinglight/alex.webp",
              use: "Ceiling-mounted lighting",
              details: "Modern ceiling fixture with soft illumination",
              price: "$39.99"
            },
            {
              name: "Vision",
              image: "/assets/ceilinglight/vision.webp",
              use: "Ceiling-mounted lighting",
              details: "Modern ceiling fixture with soft illumination",
              price: "$39.99"
            },

            {
              name: "Chobin65",
              image: "/assets/ceilinglight/chobin65.webp",
              use: "Ceiling-mounted lighting",
              details: "Modern ceiling fixture with soft illumination",
              price: "$39.99"
            },


          ]
        },
        decorative_lighting: {
          name: "Decorative Lighting",
          images: ["/assets/productimages/projectormain.webp"],
          products: [
            {
              name: "Placeholder Decorative Light",
              image: "/assets/ceilinglight/decorative.webp",
              use: "Decorative ambience lighting",
              details: "Stylish decorative light for aesthetic appeal",
              price: "$59.99"
            }
          ]
        }
      }
    },

    plumbing: {
      name: "Plumbing",
      subcategories: {
        water_systems: {
          name: "Water Systems",
          images: ["/assets/productimages/basinsink.jpg"],
          products: [
            {
              name: "Basin & Sink Plumbing Kit",
              image: "/assets/productimages/basinsink.jpg",
              use: "Basin & Sink Setup",
              details: "Durable stainless steel basin mixer tap, sink waste, and fitting pipes for residential use.",
              price: "$129.99"
            },
            {
              name: "Shower & Bath Plumbing Set",
              image: "/assets/productimages/bathroomshowers.jpg",
              use: "Shower & Bath Fittings",
              details: "Includes thermostatic shower mixer, flexible hose, wall brackets, and pipe connections.",
              price: "$159.99"
            },
            {
              name: "Bathroom Accessories Plumbing Kit",
              image: "/assets/productimages/bathroomaccessories.png",
              use: "Bathroom Accessories Plumbing",
              details: "Set of towel rail, soap dish, angle valves, and chrome-plated connectors for bathrooms.",
              price: "$89.99"
            }
          ]
        }
      }
    }
  };

  // Helper functions
  const handleCategoryClick = (categoryKey) => {
    setActiveCategory(categoryKey);
    setActiveSubcategory(null);
    setActiveOption(null);
  };

  const handleSubcategoryClick = (subcategoryKey) => {
    setActiveSubcategory(subcategoryKey);
    setActiveOption(null);
  };

  const handleOptionClick = (optionKey) => {
    setActiveOption(optionKey);
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  // Render functions for different sections
  const renderCategoryTabs = () => {
    return (
      <div className="flex flex-wrap border-b border-gray-200 mb-6">
        {Object.entries(mepProducts).map(([key, category]) => (
          <button
            key={key}
            className={`px-4 py-2 font-medium text-sm md:text-base ${activeCategory === key
              ? 'border-b-2 border-blue-500 text-blue-600'
              : 'text-gray-500 hover:text-gray-700'
              }`}
            onClick={() => handleCategoryClick(key)}
          >
            {category.name}
          </button>
        ))}
      </div>
    );
  };

  const renderSubcategories = () => {
    const category = mepProducts[activeCategory];
    if (!category.subcategories) return null;

    return (
      <div className="mb-3">
        <h2 className="text-lg font-semibold mb-3">Subcategories</h2>
        <div className="flex flex-wrap gap-2">
          {Object.entries(category.subcategories).map(([key, subcategory]) => (
            <button
              key={key}
              className={`px-3 py-1 rounded-full text-sm ${activeSubcategory === key
                ? 'bg-blue-500 text-white'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              onClick={() => handleSubcategoryClick(key)}
            >
              {subcategory.name}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const renderOptions = () => {
    if (!activeSubcategory) return null;

    const subcategory = mepProducts[activeCategory].subcategories[activeSubcategory];
    if (!subcategory.options) return null;

    return (
      <div className="mb-3">
        <h2 className="text-lg font-semibold mb-3">Options</h2>
        <div className="flex flex-wrap gap-2">
          {Object.entries(subcategory.options).map(([key, option]) => (
            <button
              key={key}
              className={`px-3 py-1 rounded-full text-sm ${activeOption === key
                ? 'bg-blue-500 text-white'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              onClick={() => handleOptionClick(key)}
            >
              {option.name}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const renderProducts = () => {
    let products = [];

    if (activeSubcategory && activeOption) {
      // Get products from options
      const option = mepProducts[activeCategory].subcategories[activeSubcategory].options[activeOption];
      if (option.products) {
        products = option.products;
      } else if (option.options) {
        // Handle nested options
        const nestedOptionKey = Object.keys(option.options)[0];
        if (option.options[nestedOptionKey].products) {
          products = option.options[nestedOptionKey].products;
        }
      }
    } else if (activeSubcategory && mepProducts[activeCategory].subcategories[activeSubcategory].products) {
      // Get products directly from subcategory
      products = mepProducts[activeCategory].subcategories[activeSubcategory].products;
    }

    if (products.length === 0) {
      return (
        <div className="text-center py-10">
          <p className="text-gray-500">Select a category and subcategory to view products</p>
        </div>
      );
    }

    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((product, index) => (
          <div
            key={index}
            className="border rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow cursor-pointer"
            onClick={() => handleProductClick(product)}
          >
            <div className="h-48 bg-gray-200 overflow-hidden">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-4">
              <h3 className="font-semibold text-lg mb-2">{product.name}</h3>
              <p className="text-gray-600 mb-2">{product.use}</p>
              {/* <p className="text-blue-600 font-bold">{product.price}</p> */}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderProductModal = () => {
    if (!isModalOpen || !selectedProduct) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
          <div className="p-6">
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-2xl font-bold">{selectedProduct.name}</h2>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="mb-2">
              <img
                src={selectedProduct.image}
                alt={selectedProduct.name}
                className="w-full h-64 object-cover rounded"
              />
            </div>

            <div className="space-y-3">
              <div>
                <h3 className="font-semibold">Uses:</h3>
                <p>{selectedProduct.use}</p>
              </div>

              <div>
                <h3 className="font-semibold">Details:</h3>
                <p>{selectedProduct.details}</p>
              </div>


            </div>

            <div className="mt-6 flex justify-end">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <ProductsNavRow />

      <div className="container mx-auto px-4 py-2">

        <div className="flex flex-col md:flex-row items-center justify-between  rounded-2xl ">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2 md:mb-0">
             Mechanical, Electrical and Plumbing (MEP)  Products
          </h1>

          <Link to="/products/lightingsolutions">
            <button
              className="px-5 py-2 bg-[#00A3A1] text-white font-medium rounded-xl shadow-md 
                 hover:bg-[#00A3A1] transition duration-300"
            >
              Industrial and Construction Lights
            </button>
          </Link>
        </div>

        {renderCategoryTabs()}
        {renderSubcategories()}
        {renderOptions()}
        {renderProducts()}
        {renderProductModal()}
      </div>
    </>
  );
};

export default MepProductsPage;
